<div class="advance-search-container" attr.style="width: {{properties.width}};">
    <div class="magnify" (click)="callParentFunctionSearch()">&#x2315;</div>
    <input type="text" style="width: 65%;" placeholder="{{properties.placeholder}}">
    <div class="line-options" (click)="callParentFunctionOptions()">
        <img style="width: 100%;" *ngIf="!expanded" src="assets/icons/filter.png" alt="Icon">
        <img style="width: 100%;" *ngIf="expanded" src="assets/icons/filter_inverted.png" alt="Icon">
    </div>
</div>